import { template as template_a679df8aade54a6c92b1a52cf0b24035 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import CardError from '@cardstack/host/components/card-error';
import type { ErrorModel as IndexRouteErrorModel } from '@cardstack/host/routes/index';
interface Signature {
    Args: {
        model: IndexRouteErrorModel;
    };
}
const IndexErrorRouteComponent: TemplateOnlyComponent<Signature> = template_a679df8aade54a6c92b1a52cf0b24035(`
  <CardError
    @type={{@model.loadType}}
    @message={{@model.message}}
    @operatorModeState={{@model.operatorModeState}}
  />
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default RouteTemplate(IndexErrorRouteComponent);
